import type { ImageProps } from '2-core-elements/Image/Image';
import type { ContentModelReference, ImageFile } from 'cms/cms-types';

interface ImgSrcSet {
    src: string;
    media: string;
}

export const generateImgSrcSet = (imgUrl: string | null, imgSrcSets: number[]): ImgSrcSet[] | undefined => {
    if (!imgUrl) {
        return undefined;
    }

    return imgSrcSets.map(width => {
        return {
            src: `${imgUrl}?width=${width} ${width}w`,
            media: `(max-width: ${width}px)`,
        };
    });
};

// on here there's it's image directly no Expanded needed.
export const resolveImageFileToImage = (data: ImageFile | null | undefined, imgSrcParam?: string, imgSrcSets?: number[]): ImageProps | undefined => {
    if (!data?.Url) {
        return undefined;
    }

    const { Height, Title, Url, Width } = data as ImageFile;
    const imgSrcSet = imgSrcSets ? generateImgSrcSet(Url || null, imgSrcSets) : imgSrcSets;

    return {
        imgSrc: `${Url}${imgSrcParam || ''}` || '',
        imgWidth: Width as number,
        imgHeight: Height as number,
        imgAlt: Title || '',
        imgSrcSet,
    };
};


// the image is reference, so it's inside Expanded
export const resolveImageReferenceToImage = (data: ContentModelReference | null | undefined, imgSrcParam?: string, imgSrcSets?: number[]): ImageProps | undefined => {
    if (!data?.Expanded) {
        return undefined;
    }

    return resolveImageFileToImage(data.Expanded, imgSrcParam, imgSrcSets);
};
